export default __webpack_public_path__ + "static/media/5.b0e5861a.svg";